<template>
  <div>
    <div class="nav-ul">
      <a
        class="nav-li"
        v-for="(item, index) in navList"
        :key="index"
        :href="'https://kjpd.kepuchina.cn/' + item.url"
      >
        <span>
          {{ item.name }}
        </span></a
      >
    </div>
    <div class="nav-ul">
      <a
        class="nav-li"
        v-for="(item, index) in navList2"
        :key="index"
        :href="'https://kjpd.kepuchina.cn/' + item.url"
      >
        <span>
          {{ item.name }}
        </span></a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "ClassList",
  components: {},
  props: {},
  data() {
    return {
      navList: [
        { name: "首页精彩", url: "" },
        { name: "科学原理", url: "2/" },
        { name: "智慧实验", url: "3/" },
        { name: "科学通识", url: "4/" },
      ],
      navList2: [
        { name: "云游科技", url: "5/" },
        { name: "大学之前", url: "6/" },
        { name: "名家讲坛", url: "7/" },
        { name: "拒绝emo", url: "8/" },
      ],
    };
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.nav-ul {
  position: relative;
  width: 740px;
  padding-top: 45px;
  margin: auto;
  font-size: 30px;
  color: white;
  text-align: center;

  .nav-li {
    color: #333;
    cursor: pointer;
  }

  .nav-li + .nav-li {
    margin-left: 45px;
  }
}
</style>
